import React from 'react';

import '../assets/css/chatbubble.css';

const UserChatBubble = ({ children }) =>
  <div className="chatbubble user">
    <div className="bubble">{children}</div>
  </div>;
export default UserChatBubble;
